/**
 * Component: Notification
 * ------------------------------------------------------------------------------
 * Simple component to remove a container on click and disable using cookies.
 *
 * @namespace notification
 */
import debounce from 'lodash-es/debounce'
import Cookies from 'js-cookie'
import log from 'salvo-lite/log'

import cssClasses from '../helpers/cssClasses'
import { on } from '../helpers/utils'
import breakpoints from '../helpers/breakpoints'

class Notification {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            close: '[js-notification="close"]',
            enableCookies: true,
            cookie: {
                expiry: 7,
                namespace: 'notification',
                value: 'dismissed'
            },
            ...JSON.parse(elem.getAttribute('data-masonry') || '{}')
        }
        this._close = this._elem.querySelector(this._settings.close)
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._settings.enableCookies && this._isCookieSet()) return

        this._setInitState()
        this._setListeners()
        this._setTriggerEvents()
    }

    _setListeners () {
        window.Frame.EventBus.listen('SiteHeader:height', (response) => this._setTopValue(response))
    }

    _setTriggerEvents () {
        on('click', this._close, (event) => this._handleCloseEvent(event))
        on('keyup', (event) => {
            if (event.keyCode === 27) {
                this._handleCloseEvent(event)
            }
        })

        on('resize', debounce(() => this._setListeners(), 250))
    }

    _setInitState () {
        this._elem.classList.add(cssClasses.active)

        window.setTimeout(() => {
            this._elem.classList.add(cssClasses.visible)
        }, 3000)
    }

    _setTopValue (height) {
        if (window.matchMedia(`(min-width: ${breakpoints.large})`).matches) {
            this._elem.style.top = `${height}px`
            return
        }

        this._elem.style.top = 'auto'
    }

    _handleCloseEvent (event) {
        event.preventDefault()
        this._elem.classList.remove(cssClasses.active)
        window.Frame.EventBus.emit('Notification:dismissed')

        if (this._settings.enableCookies) {
            Cookies.set(
                this._settings.cookie.namespace,
                this._settings.cookie.value, {
                    expires: this._settings.cookie.expiry
                }
            )
        }
    }

    _isCookieSet () {
        return typeof Cookies.get(this._settings.cookie.namespace) !== 'undefined'
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    // })
}

export default Notification



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Notification.js